import { Routes, Route, Navigate } from 'react-router-dom';
//Layouts
import { PrivateRoute } from 'components/PrivateRoute';
import { WakePortalRoute } from 'components/PrivateRoute/WakePortalRoute';
import Home from 'containers/Home';
import Login from 'containers/Authentication/Login';
import TwoFactor from 'containers/Authentication/TwoFactor';
import ForgotPassword from 'containers/Authentication/ForgotPassword';
import ResetPassword from 'containers/Authentication/ResetPassword';
import AccountValidation from 'containers/Authentication/AccountValidation';
import SsoCallback from 'containers/Authentication/SsoCallback';
import Automation from 'containers/Automation';
import ManagementDevices from 'containers/Management/Devices';
import ManagementDevicesTISData from 'containers/Management/Devices/ManagementDevicesTISData';
import ManagementGroups from 'containers/Management/Groups';
import ManagementViews from 'containers/Management/Views';
import ManagementViewsCreate from 'containers/Management/Views/ManagementViewsCreate';
import ManagementViewsDetails from 'containers/Management/Views/ManagementViewsDetails';
import ManagementPolicies from 'containers/Management/Policies';
import ManagementPermissions from 'containers/Management/Permissions';
import ManagementUsers from 'containers/Management/Users';
import ManagementOrganizations from 'containers/Management/Organizations';
import ManagementLicenses from 'containers/Management/Licenses';
import ManagementReference from 'containers/Management/Reference';
import ManagementNotifications from './containers/Management/Notifications';
import EnergyRates from './containers/Management/EnergyRates';
import GeneralSettings from 'containers/Settings/GeneralSettings';
import SecuritySettings from 'containers/Settings/SecuritySettings';
import AdvancedSettings from 'containers/Settings/AdvancedSettings';
import ReportsBatteryHealth from 'containers/OperationalReports/BatteryHealth';
import ReportsAssetInventory from 'containers/OperationalReports/AssetInventory';
import ReportsLicenseSummary from 'containers/OperationalReports/LicenseSummary';
import ReportsPolicySummary from 'containers/OperationalReports/PolicySummary';
import ReportsDeviceUsage from 'containers/ActivityReports/DeviceUsage';
import ReportsDeviceTime from 'containers/ActivityReports/DeviceTime';
import ReportsDeviceType from 'containers/OperationalReports/DeviceType';
import ReportsPowerState from 'containers/ActivityReports/Powerstate';
import ReportsSavingsSummary from 'containers/EnergyReports/SavingsSummary';
import ReportsSavings from 'containers/EnergyReports/Savings';
import ReportsAnnual from 'containers/EnergyReports/Annual';
import GenericReport from 'containers/GenericReport';
import RegisterOrganization from 'containers/Authentication/RegisterOrganization';
import AccountSettings from './containers/AccountSettings';
import ReportsGroupSummary from 'containers/OperationalReports/GroupSummary';
import PageNotFound from 'containers/PageNotFound';

const Router = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/two-factor" element={<TwoFactor />} />
            <Route path="/register" element={<RegisterOrganization />} />
            <Route path="/login/validate" element={<AccountValidation />} />
            <Route path="/login/sso_callback" element={<SsoCallback />} />
            <Route path="/login/forgot_password" element={<ForgotPassword />} />
            {/* Standalone page - authenticated, but intentionally outside the admin layout. */}
            <Route path="/wake-portal" element={<WakePortalRoute />} />
            <Route path="/login/reset_password" element={<ResetPassword title="Please reset your password" />} />
            <Route path="/login/create_password" element={<ResetPassword title="Please create your password" />} />
            <Route path="/" element={<PrivateRoute />}>
                <Route exact path="/" element={<Navigate to="/home" replace />} />
                <Route exact path="/home" element={<Home />} />
                <Route exact path="/automation" element={<Automation />} />
                <Route exact path="/account-settings" element={<AccountSettings />} />
                <Route exact path="/management/devices" element={<ManagementDevices />} />
                <Route exact path="management/devices/show_tis_data" element={<ManagementDevicesTISData />} />
                <Route exact path="/management/groups" element={<ManagementGroups />} />
                <Route exact path="/management/views" element={<ManagementViews />} />
                <Route exact path="/management/views/create" element={<ManagementViewsCreate />} />
                <Route exact path="/management/views/view_details/:id" element={<ManagementViewsDetails />} />
                <Route exact path="/management/policies" element={<ManagementPolicies />} />
                <Route exact path="/management/permissions" element={<ManagementPermissions />} />
                <Route exact path="/management/users" element={<ManagementUsers />} />
                <Route exact path="/management/organizations" element={<ManagementOrganizations />} />
                <Route exact path="/management/licenses" element={<ManagementLicenses />} />
                <Route exact path="/management/reference" element={<ManagementReference />} />
                <Route exact path="/management/notifications" element={<ManagementNotifications />} />
                <Route exact path="/management/energy_rate" element={<EnergyRates />} />

                <Route exact path="/settings/general" element={<GeneralSettings />} />
                <Route exact path="/settings/security" element={<SecuritySettings />} />
                <Route exact path="/settings/advanced" element={<AdvancedSettings />} />

                <Route exact path="/operational-reports/battery-health" element={<ReportsBatteryHealth />} />
                <Route exact path="/operational-reports/asset-inventory" element={<ReportsAssetInventory />} />
                <Route exact path="/operational-reports/license-summary" element={<ReportsLicenseSummary />} />
                <Route exact path="/operational-reports/policy-summary" element={<ReportsPolicySummary />} />
                <Route exact path="/operational-reports/group-summary" element={<ReportsGroupSummary />} />
                <Route exact path="/operational-reports/device-type" element={<ReportsDeviceType />} />

                <Route exact path="/activity-reports/device-usage" element={<ReportsDeviceUsage />} />
                <Route exact path="/activity-reports/device-time" element={<ReportsDeviceTime />} />
                <Route exact path="/activity-reports/powerstate" element={<ReportsPowerState />} />

                {/* Database-defined reports - use GenericReport component */}
                <Route exact path="/energy-reports/baseline-audit" element={<GenericReport />} />
                <Route exact path="/admin-reports/org-health" element={<GenericReport />} />

                {/* Manually created reports - keep existing components */}
                <Route exact path="/energy-reports/savings" element={<ReportsSavings />} />
                <Route exact path="/energy-reports/annual" element={<ReportsAnnual />} />
                <Route exact path="/energy-reports/savings-summary" element={<ReportsSavingsSummary />} />

                <Route path="*" element={<PageNotFound />} />
            </Route>
        </Routes>
    );
};

export default Router;
